import { useEffect, useState } from "react";
import { message } from "antd";
import { useSidebar } from "../common/SidebarContext";

export default function PersonalTab() {
  const Id = localStorage.getItem("UserId")
  const token = localStorage.getItem("token")
  const { profile } = useSidebar();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    profileS3Link: "",
    profileFile: null,
  });

  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwords, setPasswords] = useState({ current:"",new: "", confirm: "" });

  useEffect(() => {
    if (profile) {
      setFormData({
        first_name: profile?.first_name || "",
        last_name: profile?.last_name || "",
        email: profile?.email || "",
        profileS3Link: profile?.profileS3Link || "/placeholder.svg",
        profileFile: null,
      });
    }
  }, [profile]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleProfilePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        profileFile: file,
        profileS3Link: URL.createObjectURL(file), // preview only
      });
    }
  };

  const handleFormSubmit = async () => {
    if (!formData.first_name || !formData.last_name) {
      return message.error("First and Last Name are required.");
    }

    const payload = new FormData();
    payload.append("Id", Id);
    payload.append("first_name", formData.first_name);
    payload.append("last_name", formData.last_name);
    if (formData.profileFile) {
      payload.append("pic", formData.profileFile);
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/profile/`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        cache: "default",
        body: payload,
      });

      if (response.ok) {
        const data = await response.json();
        message.success("Profile updated successfully!");
      } else {
        console.log('Error:', response);
        message.error("Error in updating profile");
      }
    } catch (error) {
      console.log('Error:', error);
      message.error("Error in updating profile");

    }
  };
  
  

  const handlePasswordSubmit = async () => {
    if (!passwords.new || !passwords.confirm || !passwords.current) {
      return message.error("Both password fields and current password are required.");
    }
    if (passwords.new !== passwords.confirm) {
      return message.error("Passwords do not match.");
    }
    if (passwords.new.length < 8 ) {
      return message.error("Please add * digit long password.");
    }

    const data = {
      current_password : passwords.current,
      new_password : passwords.new,
      confirm_password : passwords.confirm
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/change-password/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        cache: "default",
        body: JSON.stringify(data),
      });
      
      if (response.ok) {
        const data = await response.json();
        message.success("Password updated successfully!");
      } else {
        console.log('Error:', response);
      }
    } catch (error) {
      console.log('Error:', error);
    }

    
    setPasswords({ new: "", confirm: "" });
    setIsChangingPassword(false);
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Personal Settings</h2>
        <p className="text-sm text-gray-600">Below is the account settings page. Make changes as you desire.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
              <input
                name="first_name"
                type="text"
                value={formData.first_name}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none custom-outline  focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
              <input
                name="last_name"
                type="text"
                value={formData.last_name}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none custom-outline focus:border-transparent"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
            <input
              name="email"
              type="email"
              value={formData.email}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md focus:outline-none"
            />
          </div>

          <div className="pt-2">
            <button
              onClick={handleFormSubmit}
              className="primary text-white px-6 py-2 font-medium transition-colors"
            >
              Update Profile
            </button>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex-1">
              <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
              <input
                type="password"
                name="current"
                value={passwords.current}
                onChange={handlePasswordChange}
                className="w-full px-3 py-2 border border-gray-300  rounded-md focus:outline-none custom-outline"
              />
            </div>
            <button
              onClick={() => setIsChangingPassword(!isChangingPassword)}
              className="ml-4 text-sm text-green-700 hover:text-green-700 font-medium"
            >
              {isChangingPassword ? "Cancel" : "Change Password"}
            </button>
          </div>

          {isChangingPassword && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
                <input
                  type="password"
                  name="new"
                  value={passwords.new}
                  onChange={handlePasswordChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none custom-outline"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Confirm Password</label>
                <input
                  type="password"
                  name="confirm"
                  value={passwords.confirm}
                  onChange={handlePasswordChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none custom-outline"
                />
              </div>
              <div className="md:col-span-2 pt-2">
                <button
                  onClick={handlePasswordSubmit}
                  className="primary text-white px-6 py-2 font-medium transition-colors"
                >
                  Update Password
                </button>
              </div>
            </div>
          )}

          <div className="pt-4">
            <button className="text-sm text-red-600 hover:text-red-700 font-medium">Delete my Account</button>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="text-center">
            <div className="w-32 h-32 mx-auto mb-4 rounded-full overflow-hidden bg-gray-200">
              <img
                src={formData.profileS3Link}
                
                className="w-full h-full object-cover"
              />
            </div>
            <label className="cursor-pointer text-sm text-green-700 hover:text-green-700 font-medium">
              Change Profile Photo
              <input
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleProfilePhotoChange}
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
